import type { RenderElementProps } from 'slate-react'
import { Avatar } from './Person'

export function ReadonlyMention({
  element,
  attributes,
  children,
}: RenderElementProps) {
  if (element.type !== 'mention') throw new Error('Unsupported file type')

  return (
    <span
      className={
        'bg-gray-10 inline-flex items-center rounded-xl py-1 pr-1.5 pl-1 align-top leading-none'
      }
      contentEditable={false}
      {...attributes}
    >
      <Avatar id={element.targetId} />
      <span className="pl-2">
        {element.name}
        {children}
      </span>
    </span>
  )
}
